<ui-control-field
  [label]="label()"
  [isRequired]="isRequired()"
  [error]="error()">
  <p-dropdown
    appendTo="body"
    [inputId]="id()"
    [placeholder]="placeholder()"
    [options]="options()"
    [ngModel]="value()"
    (onChange)="updateValue($event.value)"
    (onBlur)="markAsTouched()" />
</ui-control-field>
